import { Page } from "@/components/layout/Page";
import { WidgetFrame } from "@/components/layout/WidgetFrame";
import { DateRangeWidget } from "@/components/widgets/selects/DateRangeWidget";
import { colSpan, height } from "@/components/widgets/widget.utils";
import { usePagesState } from "@/hooks/usePagesState";
import { AttentionCustomersKPIWidget } from "@/pages/DashboardPage/sm/widgets/kpi/AttentionCustomersKPIWidget";
import { CriticalAgreementsKPIWidget } from "@/pages/DashboardPage/sm/widgets/kpi/CriticalAgreementsKPIWidget";
import { PMReportsPerAstronautKPIWidget } from "@/pages/DashboardPage/sm/widgets/kpi/PMReportsPerAstronautKPIWidget";
import { RepairsPerAstronautKPIWidget } from "@/pages/DashboardPage/sm/widgets/kpi/RepairsPerAstronautKPIWidget";
import { ServiceCostMilkKPIWidget } from "@/pages/DashboardPage/sm/widgets/kpi/ServiceCostMilkKPIWidget";
import { SparePartsCostPerAstronautKPIWidget } from "@/pages/DashboardPage/sm/widgets/kpi/SparePartsCostPerAstronautKPIWidget";

export function ServiceManagerSubpage() {
    const [dateFrom, setDateFrom] = usePagesState("dateFrom");
    const [dateTo, setDateTo] = usePagesState("dateTo");

    const queryParameters = { dateFrom, dateTo };

    return (
        <>
            <Page.StickyHeader>
                <Page.Header.Widgets>
                    <Page.Header.WidgetFrame colSpan={{ md: 12 }}>
                        <DateRangeWidget
                            onDateToChange={(value) => setDateTo(value)}
                            onDateFromChange={(value) => setDateFrom(value)}
                            dateTo={dateTo}
                            dateFrom={dateFrom}
                        />
                    </Page.Header.WidgetFrame>
                </Page.Header.Widgets>
            </Page.StickyHeader>
            <Page>
                <Page.Header>
                    <Page.Header.Widgets>
                        <Page.Header.WidgetFrame colSpan={{ md: 9 }}>
                            <Page.Header.Title value={"Dashboard"} />
                        </Page.Header.WidgetFrame>
                        <Page.Header.WidgetFrame>
                            <DateRangeWidget
                                dateFrom={dateFrom}
                                dateTo={dateTo}
                                onDateFromChange={setDateFrom}
                                onDateToChange={setDateTo}
                            />
                        </Page.Header.WidgetFrame>
                    </Page.Header.Widgets>
                </Page.Header>
                <Page.Content>
                    <Page.Content.Widgets>
                        <WidgetFrame colSpan={colSpan.kpi} height={height.kpi}>
                            <AttentionCustomersKPIWidget queryParameters={queryParameters} />
                        </WidgetFrame>
                        <WidgetFrame colSpan={colSpan.kpi} height={height.kpi}>
                            <CriticalAgreementsKPIWidget queryParameters={queryParameters} />
                        </WidgetFrame>
                        <WidgetFrame colSpan={colSpan.kpi} height={height.kpi}>
                            <ServiceCostMilkKPIWidget queryParameters={queryParameters} />
                        </WidgetFrame>
                        <WidgetFrame colSpan={colSpan.kpi} height={height.kpi}>
                            <PMReportsPerAstronautKPIWidget queryParameters={queryParameters} />
                        </WidgetFrame>
                        <WidgetFrame colSpan={colSpan.kpi} height={height.kpi}>
                            <RepairsPerAstronautKPIWidget queryParameters={queryParameters} />
                        </WidgetFrame>
                        <WidgetFrame colSpan={colSpan.kpi} height={height.kpi}>
                            <SparePartsCostPerAstronautKPIWidget queryParameters={queryParameters} />
                        </WidgetFrame>
                    </Page.Content.Widgets>
                </Page.Content>
            </Page>
        </>
    );
}
